// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vUUDc","title":"styles_title__37BeP"};